export default "/static/ec25c7b793d5a8d6.png"